import {HighTierCouponCard as HighTierCouponCardType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {useHistory} from '@aboutyou/router';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';
import {
  COLORS,
  DiscountCard,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useIsUrgencyTriggersDisabled} from '../../shared-deprecated/useIsUrgencyTriggersDisabled';
import {HighTierCouponCardThumbnails} from './HighTierCouponCardThumbnail';
interface HighTierCouponCardProps {
  card: HighTierCouponCardType;
}

export const HighTierCouponCard = (props: HighTierCouponCardProps) => {
  const history = useHistory();

  const {card} = props;

  const trackFeature = useTrackFeature();
  const hideCountdown = useIsUrgencyTriggersDisabled();

  const onClick = () => {
    trackFeature({
      label: card.featureTracker.label,
      name: card.featureTracker.name,
      eventType: 'click',
    });
    history.push(card.link.linkTarget.url || '');
  };

  const {ref} = useTrackFeatureInViewImpression<HTMLButtonElement>({
    label: card.featureTracker.label,
    name: card.featureTracker.name,
  });

  return (
    <DiscountCard
      ref={ref}
      data-testid="HighTierCouponProductCard"
      backgroundColor={COLORS.PrimaryCoupon}
      headline={props.card.headline}
      onClick={onClick}
      conditionText={props.card.info?.body}
      BackgroundIcon={<StyledIcon asset={GenericIconName.CouponCloud} />}
      DiscountCardThumbnails={
        <HighTierCouponCardThumbnails
          color={COLORS.PrimaryCoupon}
          images={props.card.images}
          label={props.card.link.label}
        />
      }
      hideCountdown={hideCountdown}
    />
  );
};

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  width: 60px;
`;
